import React from "react";
import { Container } from "./styles";
import InlineSVG from "react-inlinesvg";

export default function PluginsWaitlist({ user }) {
  return (
    <Container>
      <h1><InlineSVG src="/assets/plugin.svg" /> Plugins are in Private Beta</h1>

      <p>Plugins are a way to extend Sudowrite functionality for yourself and the community.</p>

      <p>Interested in joining? <a href={`https://airtable.com/appy38i4BmQmyKcGI/shrgX1OSrG2nMF8Ig?prefill_Email=${user.email}&prefill_Name=${user.displayName}`}>Sign up for the waitlist</a></p>
    </Container>
  );
}
